var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.29 9.74-1.67-5a.83.83 0 0 0-.79-.57h-2.5v1.66h1.9l1.11 3.34H12.5c-.92 0-1.67.74-1.67 1.66H9.17c0-.92-.75-1.66-1.67-1.66H3.66l1.1-3.34h1.9V4.17h-2.5a.83.83 0 0 0-.78.57l-1.67 5h.01a.77.77 0 0 0-.05.26v3.33a2.5 2.5 0 0 0 2.5 2.5h2.5a2.5 2.5 0 0 0 2.5-2.5v-.83h1.66v.83a2.5 2.5 0 0 0 2.5 2.5h2.5a2.5 2.5 0 0 0 2.5-2.5V10a.8.8 0 0 0-.05-.26h.01ZM7.5 13.34c0 .45-.37.83-.83.83h-2.5a.83.83 0 0 1-.84-.84v-2.5H7.5v2.5Zm9.17 0c0 .45-.38.83-.84.83h-2.5a.83.83 0 0 1-.83-.84v-2.5h4.17v2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasses);
export default ForwardRef;